// extracted by mini-css-extract-plugin
module.exports = {"root":"AuctionPage_root__3Hq0Y","submitButton":"AuctionPage_submitButton__1IQKX","selectcontrol":"AuctionPage_selectcontrol__fNU1y"};